import { useState, useEffect } from "react";
import {
  Box,
  MenuItem,
  Typography,
  CircularProgress,
} from "@mui/material";
import { fetchProductStrainsAPI } from "../../redux/apis/products";

const RuleOptionIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    style={{ marginRight: 4, flexShrink: 0 }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2978 7.50022C12.2714 10.3996 9.89959 12.7286 7.00022 12.7022C4.10084 12.6758 1.77185 10.3039 1.79826 7.40457L1.84608 2.15479L12.3456 2.25044L12.2978 7.50022ZM7.00891 11.7477C9.38113 11.7693 11.3217 9.86374 11.3433 7.49152L11.3824 3.19625L2.79189 3.11799L2.75277 7.41327C2.73116 9.78548 4.6367 11.7261 7.00891 11.7477Z"
      fill="#475CC7"
    />
  </svg>
);

/**
 * StrainList fetches strains from /api/v1/strain/selection/listing and displays them.
 * On select, calls changeHandler with the selected strain object. No sub-traits.
 */
export default function StrainList({
  changeHandler = () => {},
  inputValue = null,
  setAnchorEl,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [strainsList, setStrainsList] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    fetchProductStrainsAPI()
      .then((res) => {
        const data = res?.data ?? res?.strains ?? res;
        const list = Array.isArray(data) ? data : [];
        setStrainsList(list);
      })
      .catch(() => setStrainsList([]))
      .finally(() => setIsLoading(false));
  }, []);

  const isSelected = (strain) => {
    if (inputValue == null) return false;
    const id = inputValue?._id ?? inputValue?.id ?? inputValue?.slug;
    return (strain?._id ?? strain?.id ?? strain?.slug) === id;
  };

  return (
    <Box sx={{ minWidth: 220 }}>
      {!isLoading && strainsList.length === 0 && (
        <Box sx={{ p: 2, transform: "scale(0.9)" }}>No strains found</Box>
      )}
      <Box sx={{ maxHeight: 300, overflow: "auto" }}>
        {strainsList.map((strain, index) => {
          const selected = isSelected(strain);
          const name = strain?.strainName ?? strain?.name ?? strain?.slug ?? "-";
          return (
            <MenuItem
              key={strain?._id ?? strain?.id ?? strain?.slug ?? index}
              selected={selected}
              onClick={() => {
                if (typeof setAnchorEl === "function") setAnchorEl(null);
                changeHandler({
                  ruleValue: selected ? null : strain,
                });
              }}
              sx={{ py: 1 }}
            >
              <RuleOptionIcon />
              <Typography
                sx={{
                  paddingLeft: 1,
                  color: "",
                  fontWeight: selected ? 600 : 400,
                }}
              >
                {name}
              </Typography>
            </MenuItem>
          );
        })}
      </Box>
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
          <CircularProgress size={24} color="primary" />
        </Box>
      )}
    </Box>
  );
}
